export enum PlanType {
  Backup = 'backup',
  Restore = 'restore'
}
